var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-full-page-wrapper"},[_c('div',{staticClass:"inner"},[_vm._t("default"),(_vm.showArrow && _vm.$vuetify.breakpoint.xsOnly)?_c('icon-button',{class:['scroll-arrow', `scroll-arrow--${_vm.arrowColor}`],on:{"click":_vm.onScroll}},[_c('arrow-icon')],1):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }